import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsAccountsTable from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccountsTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findManagedSolutionsAccounts, exportManagedSolutionsAccounts} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {ManagedSolutionsAccountsColumns} from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccounts.types"
import {useQueryState} from "use-location-state"
import {downloadFile} from "../../utilities/file"
import {useToasts} from "react-toast-notifications"

export function ManagedSolutionsAccountsPage(): ReactElement {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const limit = 40

	const [sortBy, setSortBy] = useQueryState("rtl-acc--sort", "-createdAt")

	const [result, hasPrev, hasNext, prev, next, hasResults, reset] = usePaging(
		limit,
		(offset, limit) => findManagedSolutionsAccounts(accessToken, offset, limit, undefined, undefined, sortBy),
		(x) => x.data.length,
		[sortBy],
		"rtl-acc",
		true
	)

	const toggleSort = () => {
		setSortBy(sortBy === "-createdAt" ? "createdAt" : "-createdAt")
		reset(limit)
	}

	async function exportAccounts() {
		const response = await exportManagedSolutionsAccounts(accessToken, undefined, undefined, sortBy)
		response.match(
			(d) => downloadFile("ManagedSolutionsAccounts.csv", d, "text/csv"),
			() => addToast("Something went wrong", {appearance: "warning"})
		)
		return true
	}

	return (
		<>
			<TitleBar title={"Accounts"} />

			<MainSectionTable>
				<DataTableCard className={"managed-solutions-accounts-card"}>
					<DataTableActionHeader enableSticky={true} exportFunc={exportAccounts} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={6} />}>
						{({value: accounts}) => {
							return (
								<ManagedSolutionsAccountsTable
									accounts={accounts.data}
									hasResults={hasResults}
									hasPrev={hasPrev}
									hasNext={hasNext}
									prev={prev}
									next={next}
									isUsingPaging={true}
									fullHeight={true}
									meta={accounts.meta}
									includedColumns={[
										ManagedSolutionsAccountsColumns.id,
										ManagedSolutionsAccountsColumns.userIds,
										ManagedSolutionsAccountsColumns.type,
										ManagedSolutionsAccountsColumns.createdAt,
										ManagedSolutionsAccountsColumns.status,
										ManagedSolutionsAccountsColumns.balance,
									]}
									sortBy={sortBy}
									sortFunction={toggleSort}
								/>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
